module.exports = __webpack_public_path__ + "img/图层 1952.cad982e2.png";